import { getAPIUrl } from "../config";

const API_URL = getAPIUrl()

export const fetchAreas = async (venueId, getAccessTokenSilently) => {
    try {
      const token = await getAccessTokenSilently();
      
      const response = await fetch(`${API_URL}/api/v1/venues/${venueId}/areas`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
  
      if (!response.ok) {
        throw new Error('Failed to fetch areas');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching areas:', error);
      throw error;
    }
};

export const addArea = async (venueId, newArea, getAccessTokenSilently) => {
    try {
      const token = await getAccessTokenSilently();
      const response = await fetch(`${API_URL}/api/v1/venues/${venueId}/areas`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(newArea)
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error);
      }
      return await response.json();
    } catch (error) {
      console.error('Error adding area:', error);
      throw error;
    }
  };
  
  export const updateArea = async (venueId, updatedArea, getAccessTokenSilently) => {
    try {
      const token = await getAccessTokenSilently();
      const response = await fetch(`${API_URL}/api/v1/venues/${venueId}/areas/${updatedArea.id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedArea)
      });
      if (!response.ok) {
        throw new Error('Failed to update area');
      }
      return await response.json();
    } catch (error) {
      console.error('Error updating area:', error);
      throw error;
    }
  };
  
  export const deleteArea = async (venueId, areaId, getAccessTokenSilently) => {
    try {
      const token = await getAccessTokenSilently();
      const response = await fetch(`${API_URL}/api/v1/venues/${venueId}/areas/${areaId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error);
      }
    } catch (error) {
      console.error('Error deleting area:', error);
      throw error;
    }
  };
  